import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router";
import ReactDOM from "react-dom/client";
import "react-phone-input-2/lib/style.css";
import "./index.css";

import reportWebVitals from "./reportWebVitals";
import App from "./App";
import Payment from "./components/payment-component/payment";
import Product from "./components/product-component/product";
import ApiService from "./services/api.service";

// import Renewal from './components/product-component/product';
import Login from "./components/Pages/login";
import Register from "./components/Pages/register";
import Renewal from "./components/Pages/renewal";
import Transaction from "./components/Pages/transaction";
import ExpressCheckout from "./components/Pages/express-checkout";
import OAuthCallback from "./components/oauth";
import {
  isLocalhost,
  getEnvironmentConfiguration,
} from "./common/environments";

import Helper from "./common/helper";

const root = ReactDOM.createRoot(document.getElementById("root"));
export let baseUrl =
  "/wp-content/themes/accor-plus/modules/payment-portal/files/webapp-payments-release";

if (isLocalhost()) {
  baseUrl = "/wp-content/themes/accor-plus/modules/payment-portal/files/webapp-payments-release";
} else {
  baseUrl = window.location.pathname;
}

(async () => {
  const selectedCountry = Helper.lookupCurrentCountry();
  const queryParams = new URLSearchParams(window.location.search);
  const ipResponse = await ApiService.getIpAddress();


  if (!isLocalhost() && window.location.pathname.indexOf("renewals") != -1) {
    root.render(
      <React.StrictMode>
        <Router>
          <Routes>
            <Route
              path={baseUrl}
              element={<Renewal baseUrl={baseUrl} isLogged={true} />}
            />
          </Routes>
        </Router>
      </React.StrictMode>
    );
  } else if (
    !isLocalhost() &&
    window.location.pathname.indexOf("express-checkout") != -1
  ) {
    root.render(
      <React.StrictMode>

        <Router>
          <Routes>
            <Route
              path={baseUrl}
              element={<ExpressCheckout baseUrl={baseUrl} isLogged={true} />}
            />
          </Routes>
        </Router>
      </React.StrictMode>
    );
  } else {
    root.render(
      <React.StrictMode>

        <App baseUrl={baseUrl} />
      </React.StrictMode>
    );
  }

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
})();
